





































































































































































































































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {DiagramActionType, DiagramModeType, DiagramZoomType} from '@e/diagrams';
import ToolbarToogleIconButton from '@c/toolbar/ToolbarToogleIconButton.vue';
import ToolbarIconButton from '@c/toolbar/ToolbarIconButton.vue';
import {CursorDiagramState, MarkerCursorData} from '@/logic/cursorDiagramState';
import {Cursor} from '@/logic/cursors/cursor';
import {CursorManager} from '@/logic/cursors/cursorManager';
import {CursorType} from '@/enums/diagrams';
import FindPeaksMenuButton from '@c/toolbar/FindPeaksMenuButton.vue';
import ZoomMenuButton from '@c/toolbar/ZoomMenuButton.vue';
import {DiagramMode} from '@/interfaces/diagrams';
import {DiagramModule} from '@/store/modules/diagramModule';
import {SimpleCursor} from '@/logic/cursors/simpleCursor';
import {HarmonicCursor} from '@/logic/cursors/harmonicCursor';
import {ModulationCursor} from '@/logic/cursors/modulationCursor';
import {MarkerCursor} from '@/logic/cursors/markerCursor';
import SimpleDialog from '@c/SimpleDialog.vue';
import IconButton from '@c/controls/IconButton.vue';
import dtcpTahoModule from '@/store/modules/entities/pmodules/dtcp/dtcpTahoStoreModule';
import {getDateWithTime} from '@u/dateTimeUtils';

@Component({
  components: {
    ToolbarToogleIconButton,
    FindPeaksMenuButton,
    ZoomMenuButton,
    ToolbarIconButton,
    SimpleDialog,
    IconButton,
  },
})
export default class CursorDiagramToolbar extends Vue {
  isViewMode(modeId: any) {
    return modeId === DiagramModeType.View;
  }

  get isSkipZoomButtonDisabled() {
    const index = this.modes.findIndex(mode => mode.id === DiagramModeType.View);
    return !this.applyStatuses[index];
  }

  isFindPeaksMode(modeId: any) {
    return modeId === DiagramActionType.FindPeaks;
  }

  cursors: Cursor[] | undefined = [];
  menuPalette = false;
  matchColor = 'black';

  @Prop({required: true})
  cursorManager!: CursorManager;

  //список состояний отдельных v-btn-toogle
  activeStates: Array<number | undefined> = [];

  //список статусов применения режимов\действий
  applyStatuses: boolean[] = [];

  @Prop({required: false})
  diagramStoreModule!: DiagramModule;

  // Показатель активности кнопок тулбара
  @Prop({required: true, type: Boolean})
  disabled!: boolean;

  // Список режимов работы
  @Prop({required: true, type: Array})
  modes!: DiagramMode[];

  // Предустановленные режимы работы
  @Prop({type: Array})
  preselectedModes!: DiagramMode[];

  // Текущий тип зума
  @Prop({required: true})
  zoomType!: DiagramZoomType;

  // Показатель применения зума
  @Prop({required: true})
  isInZoom!: boolean;

  // Показатель возможности скачать картинку графика
  @Prop({required: false, default: false})
  isCanDownloadChart!: boolean;

  // Показатель возможности подгрузить спектр по курсору времени
  @Prop({required: false, default: false})
  isCanObtainSpectrum!: boolean;
  @Prop({required: false})
  spectrumDiagramBoxes: any;

  @Prop({required: false})
  span_nodes!: any;

  @Prop({required: false})
  timestamp: any;

  dynamicLabels: string[] = [];

  nonNegativeNumberRule = (v: any) => v >= -1 || 'Поле должно быть неотрицательным числом';
  integerNumberRule = (v: any) => Number.isInteger(Number(v)) || 'Поле должно быть целым числом';

  base_freq = '';
  taho_freq: any[] = [];

  get span_frequencies() {
    if (!this.base_freq)
      this.base_freq =
        this.span_nodes && this.span_nodes?.length ? this.span_nodes[0].default_rotation_value : '';
    let base_freq = parseFloat(this.base_freq);

    let freq: any[] = [
      {
        description: `${base_freq.toFixed(3)} — частота вращения вала`,
        label: 'частота вращения вала',
        marker: 'Fвр',
        value: base_freq.toFixed(3),
      },
    ];

    if (this.taho_freq)
      this.taho_freq.forEach((tf: any) => {
        if (!base_freq && tf.value > 0) {
          base_freq = tf.value;
          this.base_freq = `${tf.value}`;
          freq[0] = tf;
        } else if (tf.value > 0) {
          freq.push(tf);
        }
      });

    if (this.span_nodes)
      this.span_nodes.forEach((span: any) => {
        freq = freq.concat(
          span.frequencies
            .filter((f: any) => f.is_enabled && !f.is_deleted)
            .map((f: any) => {
              const frequency = (f.is_absolute ? f.frequency : f.frequency * base_freq).toFixed(3);
              return {
                description: `${frequency} — ${f.name}`,
                label: f.name,
                marker: f.name,
                value: frequency,
              };
            }),
        );
        span.bearings.forEach((b: any) => {
          if (b.is_deleted) return;
          const bearing_freq = base_freq * b.complexity;
          const cage_freq = (bearing_freq * b.bearing.cage_frequency).toFixed(3);
          if (parseFloat(cage_freq) > 0)
            freq.push({
              description: `${cage_freq} — ${b.bearing.name}: частота вращения сепаратора`,
              label: `${b.bearing.name}: частота вращения сепаратора`,
              marker: `${b.bearing.name}.Fсеп`,
              value: cage_freq,
            });
          const roller_freq = (bearing_freq * b.bearing.roller_frequency).toFixed(3);
          if (parseFloat(roller_freq) > 0)
            freq.push({
              description: `${roller_freq} — ${b.bearing.name}: частота контакта тел качения`,
              label: `${b.bearing.name}: частота контакта тел качения`,
              marker: `${b.bearing.name}.Fтк`,
              value: roller_freq,
            });
          const inner_freq = (bearing_freq * b.bearing.inner_frequency).toFixed(3);
          if (parseFloat(inner_freq) > 0)
            freq.push({
              description: `${inner_freq} — ${b.bearing.name}: частота перекатывания тел качения по внутреннему кольцу`,
              label: `${b.bearing.name}: частота перекатывания тел качения по внутреннему кольцу`,
              marker: `${b.bearing.name}.Fв`,
              value: inner_freq,
            });
          const outer_freq = (bearing_freq * b.bearing.outer_frequency).toFixed(3);
          if (parseFloat(outer_freq) > 0)
            freq.push({
              description: `${outer_freq} — ${b.bearing.name}: частота перекатывания тел качения по внешнему кольцу`,
              label: `${b.bearing.name}: частота перекатывания тел качения по внешнему кольцу`,
              marker: `${b.bearing.name}.Fн`,
              value: outer_freq,
            });
        });
      });
    return freq.sort((a, b) => a.value - b.value);
  }

  // Выбранные режимы
  get selectedModes() {
    return this.applyStatuses
      .map((s: boolean, index: number) => ({s, index}))
      .filter(p => p.s)
      .map(p => this.modes[p.index]);
  }

  /*
    TODO 1. Из-за того, что computed свойства не обновляются при обновлении отдельных элементов
    зависимого массива, приходится заменять весь массив
  */
  set selectedModes(value: DiagramMode[]) {
    const activeStates = [...this.activeStates];
    const applyStatuses = [...this.applyStatuses];
    this.modes.forEach((mode, index) => {
      if (value.some(m => m.id === mode.id)) {
        activeStates[index] = 0;
        applyStatuses[index] = true;
      } else {
        activeStates[index] = undefined;
        applyStatuses[index] = false;
      }
    });
    this.activeStates = [...activeStates];
    this.applyStatuses = [...applyStatuses];
  }

  // Показывать линию
  showCursorLineIndex: number | null = 0;
  get showCursorLine() {
    return this.showCursorLineIndex != null; //check both null and undefined
  }
  set showCursorLine(value: boolean) {
    if (value) this.showCursorLineIndex = 0;
    else this.showCursorLineIndex = null;
  }

  // Показывать отметки курсора
  showCursorTooltipsIndex: number | null = null;
  get showCursorTooltips() {
    return this.showCursorTooltipsIndex != null; //check both null and undefined
  }
  set showCursorTooltips(value: boolean) {
    if (value) this.showCursorTooltipsIndex = 0;
    else this.showCursorTooltipsIndex = null;
  }

  // Показатель того, что выбран один из режимов курсора
  get someCursorModeSelected() {
    return this.selectedModes.some(mode => mode.type === DiagramModeType.Cursor);
  }

  // Данное событие вызываем на клик по кнопке, т. к. событие change на v-btn-toggle
  // не передает текущий выбранный элемент
  selectMode(mode: DiagramMode, e: any) {
    //TODO: потом понадобится механизм передачи значений с интерфейса в режимы

    mode.value = e;

    const applyStatuses = [...this.applyStatuses];
    const activeStates = [...this.activeStates];

    //тут удаляем все несовместимые режимы
    this.modes.forEach((m, index) => {
      if (!mode.compatibleModeIds.includes(m.id) && mode.id !== m.id) {
        activeStates[index] = undefined;
        applyStatuses[index] = false;
      }
    });

    const modeIndex = this.modes.indexOf(mode);
    if (!applyStatuses[modeIndex]) {
      applyStatuses[modeIndex] = true;
    } else {
      applyStatuses[modeIndex] = false;
    }

    const viewMode = this.modes.filter(x => x.type === 'view');
    const viewModeIndex = this.modes.indexOf(viewMode[0]);

    // при снятии режима курсора возвращаем режим просмотра
    if (mode.type === 'cursor' && applyStatuses[modeIndex] == false) {
      viewMode[0].value = 'x';
      applyStatuses[viewModeIndex] = true;
    }

    this.applyStatuses = [...applyStatuses];
    this.activeStates = [...activeStates];

    this.$emit('selectModes', this.selectedModes);
  }

  created() {
    const activeStates: Array<number | undefined> = [];
    const applyStatuses: boolean[] = [];

    this.modes.forEach((mode: DiagramMode, index: number) => {
      activeStates[index] = undefined;
      applyStatuses[index] = false;
      if (
        this.preselectedModes.some((preselectedMode: DiagramMode) => mode.id === preselectedMode.id)
      ) {
        activeStates[index] = 0;
        applyStatuses[index] = true;
      }
    });

    this.activeStates = [...activeStates];
    this.applyStatuses = [...applyStatuses];
  }

  /* Установить свойства по состоянию */
  setupState(state: CursorDiagramState) {
    this.showCursorLine = state.isShowLine;
    this.selectedModes = state.activeModes;
    this.showCursorTooltips = state.isShowTooltips;
  }

  comboChanged(idx: number, value: any) {
    const elem: any = this.span_frequencies.find((x: any) => x.value == value);
    this.dynamicLabels[idx] = 'Значение: ' + (elem?.label || '');
  }

  cursorDialog = false;
  formValid = false;

  cursorSettingsChanged() {
    const cvals: any[] =
      this.span_nodes && this.span_nodes.length
        ? (this.$refs.cursorcombo as any[])
        : (this.$refs.cursorvalue as any[]);
    this.cursors?.forEach((c, i) => {
      const cd = c.getCursorData();
      const c_value = cvals[i].$refs?.input?.value || cvals[i].lazyValue;
      cd.pointX = parseFloat(c_value);
      if (this.span_nodes && this.span_nodes.length) {
        const elem: any = this.span_frequencies.find((x: any) => x.value == c_value);
        if (elem) (c as SimpleCursor).userTitle = elem.marker;
        else (c as SimpleCursor).userTitle = '';
      }
      if (c instanceof MarkerCursor) {
        const c2vals: any[] = this.$refs.cursor2value as any[];
        (cd as MarkerCursorData).firstPointX = parseFloat(c2vals[i].lazyValue);
      }
      if (c instanceof HarmonicCursor) {
        const nlines: any[] = this.$refs.cursornumlines as any[];
        cd.linesCount = parseInt(nlines[i].lazyValue);
        const slines: any[] = this.$refs.cursorsublines as any[];
        if (slines && slines[i]) cd.subLinesCount = parseInt(slines[i].lazyValue);
        const freqs: any[] = this.$refs.cursorsubfreq as any[];
        if (freqs && freqs[i]) cd.subLinesFreqShift = parseFloat(freqs[i].lazyValue);
      }
      if (c instanceof ModulationCursor) {
        const cm: ModulationCursor = c as ModulationCursor;
        const nlines: any[] = this.$refs.cursornumlines as any[];
        const nl_value = nlines[i].lazyValue;
        if (cm.linesCount != nl_value) {
          cm.linesCount = parseInt(nl_value);
        }
      }
      c.clear();
      c.init(
        this.cursorManager,
        this.cursorManager.getChart(),
        this.cursorManager.bindedSeriesIds,
        this.cursorManager.isShowLine,
        this.cursorManager.isShowTooltips,
        cd,
      );
      c.update(
        this.cursorManager.isShowLine,
        this.cursorManager.isShowTooltips,
        cd,
        this.cursorManager.bindedSeriesIds,
      );
      if (c instanceof SimpleCursor) (c as SimpleCursor).notify();
    });
  }

  openCursorDialog() {
    if (this.span_nodes)
      this.span_nodes.forEach(async (span: any) => {
        if (span.taho_module) {
          for (const ts of Array.isArray(this.timestamp) ? this.timestamp : [this.timestamp]) {
            const ts_str = getDateWithTime(ts);
            const {dataSet} = await dtcpTahoModule.getSignal({
              id: span.taho_module.id,
              dateInterval: {startDateTime: ts, endDateTime: ts + 60000},
              fieldAlias: 'mean',
            });
            const freq = parseFloat(dataSet[0].y);
            this.taho_freq.push({
              description: `${freq.toFixed(3)} — показания тахометра ${
                span.taho_module.id
              } (${ts_str})`,
              label: `показания тахометра ${span.taho_module.id} (${ts_str})`,
              marker: 'Fвр',
              value: freq.toFixed(3),
            });
          }
        }
      });

    this.cursors = this.cursorManager.getCursors();
    this.dynamicLabels = this.cursors.map((c: any) => {
      const val = c.getCursorData()?.pointX ? c.getCursorData()?.pointX.toFixed(3) : '';
      const elem: any = this.span_frequencies.find((x: any) => x.value == val);
      return 'Значение: ' + (elem?.label || '');
    });
    this.cursorDialog = true;
  }

  addCursor() {
    const cursorType = this.selectedModes.slice(-1)[0].id as CursorType;
    this.cursorManager.getNewCursor(cursorType);
    this.cursors = this.cursorManager.getCursors();
  }

  removeCursor(item: Cursor) {
    this.cursorManager.removeCursor(item);
    this.cursors = this.cursorManager.getCursors();
    if (item instanceof SimpleCursor) (item as SimpleCursor).notify();
  }

  obtainSpectrum(item: Cursor) {
    this.$emit('obtainSpectrum', item.getCursorData().pointX);
    this.cursorDialog = false;
  }

  needMarker(cd: any) {
    return cd instanceof MarkerCursorData;
  }

  diagtask(id: number) {
    const {href} = this.$router.resolve({
      name: 'EditDiagTask',
      params: {id: `${id}`},
    });
    window.open(href, '_blank');
  }

  getIcon(cursorType: string) {
    const mode = this.modes.find(x => x.id === cursorType);
    return mode?.icon ? `mdi-${mode.icon}` : 'mdi-help-circle';
  }

  getIconRotation(cursorType: string) {
    const mode = this.modes.find(x => x.id === cursorType);
    const rot: number = mode?.degreeRotateIcon ?? 0;
    return rot > 0 ? `mdi-rotate-${rot}` : '';
  }
}
